import React, { useState, useEffect, useRef } from "react";
import { Button, TextField, Typography, Stack, Paper, Grid, Container, Box, Divider, FormControlLabel, Switch, Skeleton, Snackbar, Tooltip, IconButton, List, ListItem, ListItemButton, CircularProgress, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import api from "../api";


const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
}));

const RESEND_TIMEOUT = 30; // seconds

const VerifyMFA = (props) => {
    const { mfaMethods, username } = useLocation().state
    const { loginToken } = useParams()
    const { t, i18n } = useTranslation();
    const [code, setCode] = useState("")
    const [selectedMethod, setSelectedMethod] = useState("")
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [resendTimer, setResendTimer] = useState(RESEND_TIMEOUT)
    const intervalRef = useRef(null);

    const navigate = useNavigate()
    const params = useParams()


    const handleResendCode = async () => {
        if (resendTimer > 0) return; // Prevent resending if timer is active
        setLoading(true);
        try {
            await api.post('/send-mfa-code/', { token: loginToken, method: selectedMethod, username: username });
            setSuccess(true);
        } catch (error) {
            setError("Failed to resend code");
        }
        setResendTimer(RESEND_TIMEOUT);
        setLoading(false);
        setCode(""); // Clear the code input after resending
        setSuccess(false);
        setError(""); // Clear any previous error messages
    };

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setResendTimer(prev => Math.max(prev - 1, 0));
            console.log(`Resend timer: ${resendTimer}`);
        }, 1000);
        return () => clearInterval(intervalRef.current); // Cleanup on unmount
    }, []);
   



    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            let res = await api.verifyMFACode({ token: loginToken, code: code, method: selectedMethod, username: username, mfa_type: selectedMethod })
            if (res.status === 200) {
                let accessToken = res.data.access
                let refreshToken = res.data.refresh
                // localStorage.setItem("accessToken", accessToken);
                // localStorage.setItem("refreshToken", refreshToken);
                navigate("/")
                await props.verifyAuth()
            }
            else {
                setError("Invalid code")
            }
        }
        catch (error) {
            setError("Invalid code")
        }
        setLoading(false)
    }

    const handleSelectMethod = (method) => {
        if (method === "email") {
            api.post('/send-mfa-code/', { token: loginToken, method: "email", username: username })
        }
        setSelectedMethod(method)
    }


    if (!loginToken) {
        navigate("/login")
    }

    if (!selectedMethod) {
        // choose method
        return (
            <Container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}
            >
                <Paper elevation={3} style={{ padding: 20, marginBottom: 20 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        {t('Choose your MFA method')}
                    </Typography>
                    <List>
                        {mfaMethods.map((method, index) => (
                            <ListItem key={index}>
                                <StyledListItemButton onClick={() => handleSelectMethod(method)}>
                                    {t(method)}
                                </StyledListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            </Container>
        )
    }

    return (
        <Container
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
            }}
        >
            <Paper elevation={3} style={{ padding: 20, marginBottom: 20 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    {t('Verify your MFA')}
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        {
                            selectedMethod === "email" &&
                            <Typography variant="body1" gutterBottom>
                                {t('A code has been sent to your email')}
                            </Typography>
                        }
                        {
                            selectedMethod === "totp" &&
                            <Typography variant="body1" gutterBottom>
                                {t('Open your authenticator app and enter the code')}
                            </Typography>
                        }
                        <TextField
                            label={t('Code')}
                            variant="outlined"
                            value={code}
                            autoFocus
                            onChange={(e) => setCode(e.target.value)}
                            helperText={
                                selectedMethod == "email" ? <Button variant="text" 
                                    onClick={handleResendCode}
                                disabled={loading || resendTimer > 0} >
                                    {t('Resend code')} {resendTimer > 0 ? `(${resendTimer} s)` : ''}
                                </Button> : t('Enter the code from your authenticator app')
                            }
                        />
                        {/* {
                            selectedMethod === "email" &&
                            <Button variant="text" onClick={() => api.post('/send-mfa-code/', { token: loginToken, method: "email", username: username })} disabled={loading} sx={{ width: 'fit-content' }} color="inherit">
                                {t('Resend code')}
                            </Button>
                        } */}
                        <Stack direction="row-reverse" spacing={2}>
                            <Button type="submit" variant="contained" disabled={loading}>{
                                loading ? <CircularProgress size={24} /> : t('Verify')}
                            </Button>

                        </Stack>
                        {error && <Typography color={"error"} variant="body1" gutterBottom>
                            {error}
                        </Typography>}
                    </Stack>
                </form>
            </Paper>
        </Container>
    )
}
export default VerifyMFA